/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.ResourceCategories {
    "use strict";

    export class resourceCategoriesContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
      serviceFilterCriteria: any;

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            rootScope: ng.IRootScopeService) {
            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService, null, false);
            this.baseEndpoint = appSettings.API_ENDPOINTS.resourceCategory;
            this.sectionTemplatePath = "app/plugins/resourceCategories/sectionViews/";
            this.buildCrudSecurityKeysBase(this.securityKeys.DATA_RESOURCECATEGORY_TAB_MAIN, true, true, true, true, true);
            this.entityType = 'ResourceCategory';
            this.updatedSelectedServieList();
            this.initializeSections();
        }

        initializeSections(): void {
         if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_RESOURCECATEGORY_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(0, "SECTION_RESOURCE_CATEGORY_MAIN", "main.html", true, false, this.baseEndpoint, "",
                    this.loggingService, this.dataService, this.identityService, Meevo.Model.NounEnum.ResourceCategoryMain, null, this.securityKeys.DATA_RESOURCECATEGORY_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
            }
        }

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
            this.businessTypeDetail = model.businessTypeDetail;
            this.updatedSelectedServieList();
        }

        postCopy(): void {
            super.postCopy();
            let model = this.castModel<Model.ResourceCategory>();
            model.displayName = undefined;
        }

        updatedSelectedServieList(): void {
          var resourceCat = this.castModel<Model.ResourceCategory>();
          if (Model.Guard.isSomething(resourceCat)) {
            // Collect ids from both service collections
            var selectedIdList = Model.Guard.isNothing(resourceCat.services) || resourceCat.services.length < 1
              ? null : _.pluck(resourceCat.services, 'id');
            // Build paging criteria
            this.serviceFilterCriteria = {
              ExcludeIdList: selectedIdList
            };
          }
        }

        save(): angular.IPromise<any> {
          return super.save().then((data: any) => {
            this.updatedSelectedServieList();
          });
        }

    }
}